import React, { useEffect, useMemo, useState } from 'react';
import '../CSS/DesafiosChallenges.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPuzzlePiece, faUsers, faClock } from '@fortawesome/free-solid-svg-icons';

/*Deixar comentado até haver um novo banner */
/*import SummerBanner from './../Components/Banner/PromocaoVerao';*/

/*Imagens: manter os nomes 'backgroundImage' e 'cardImage'. 'backgroundImageMobile' é para versão mobile*/
/*import backgroundImage from '../Images/Imagem3.png';*/
/*import backgroundImage from '../Images/fundoNatal.png';*/
import backgroundImage from '../Images/fundoUniversoTempo.png';
/*import backgroundImageMobile from '../Images/fundoNatalCard.png';*/
import backgroundImageMobile from '../Images/cardMobileTempo.png';
/*import cardImage from '../Images/card.png';*/
import cardImage from '../Images/cardUniversoTempo.png';
/*import cardImage from '../Images/cardNatal.png';*/

const Desafios = () => {

    //List of current challenges
    //Each element has a title, description, level, duration, and participants
    const [challenges, setChallenges] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [poppedBalloons, setPoppedBalloons] = useState({});

    useEffect(() => {
        //fetch available challenges
        const fetchChallenges = async () => {
            try {
                const response = await fetch('https://personal-d4yby5if.outsystemscloud.com/Booking_API/rest/Challenges/v3/Get');
                if (!response.ok) {
                    throw new Error('Failed to fetch challenges');
                }
                const data = await response.json();
        
                setChallenges(data);
                setHasError(false);
            } catch (error) {
                console.error('Error fetching challenges:');
                setHasError(true);
            } finally {
                setIsLoading(false);
            }
        };

        fetchChallenges();
    
    }, []);

    const handleClick = (desafioId) => {
        localStorage.setItem('selectedChallenge', desafioId);
    };

    const handlePopBalloon = (id) => {
        setPoppedBalloons((prev) => ({ ...prev, [id]: true }));
    };

    const sortedChallenges = useMemo(() => {
        if (!Array.isArray(challenges)) return [];
        return [...challenges].sort((a, b) => (a?.Order ?? 0) - (b?.Order ?? 0));
    }, [challenges]);

    const LevelDots = ({ level = 1 }) => {
        const safeLevel = Math.max(1, Math.min(5, Number(level) || 1));
        return (
            <div
                className="er-level"
                aria-label={`Dificuldade ${safeLevel} em 5`}
                title={`Dificuldade: ${safeLevel}/5`}
            >
                {Array.from({ length: 5 }).map((_, idx) => (
                    <FontAwesomeIcon
                        key={idx}
                        icon={faPuzzlePiece}
                        className={`er-levelDot ${idx < safeLevel ? 'is-on' : 'is-off'}`}
                    />
                ))}
            </div>
        );
    };

    const ChallengeCard = ({ challenge }) => {
        const [showPrices, setShowPrices] = useState(false);
        const isActive = challenge?.IsActive === true;

        return (
            <article className={`er-chCard ${isActive ? '' : 'is-inactive'}`}>
                <div className="er-chCardTop">
                    <h3 className="er-chTitle">{challenge.TitlePT}</h3>
                    <p className="er-chDesc">{challenge.DescriptionPT}</p>

                    {isActive && (
                        <>
                            <div className="er-chActions">
                                <button className="er-chLinkBtn" type="button" onClick={() => setShowPrices(v => !v)}>
                                    {showPrices ? 'Esconder preços' : 'Ver preços'}
                                </button>
                            </div>

                            {showPrices && (
                                <div className="er-priceBox" aria-label="Tabela de preços">
                                    <div className="er-priceRow"><span>5 elementos</span><span>50€</span></div>
                                    <div className="er-priceRow"><span>4 elementos</span><span>45€</span></div>
                                    <div className="er-priceRow"><span>3 elementos</span><span>40€</span></div>
                                    <div className="er-priceRow"><span>2 elementos</span><span>35€</span></div>
                                    <div className="er-priceRow"><span>1 elemento</span><span>25€</span></div>
                                </div>
                            )}
                        </>
                    )}
                </div>

                <div className="er-chMeta">
                    <div className="er-metaItem" title="Duração">
                        <FontAwesomeIcon icon={faClock} className="er-metaIcon" />
                        <span>{challenge.Duration}</span>
                    </div>
                    <div className="er-metaItem" title="Número de elementos">
                        <FontAwesomeIcon icon={faUsers} className="er-metaIcon" />
                        <span>{challenge.Participants}</span>
                    </div>
                </div>

                <div className="er-chCardBottom">
                    <LevelDots level={challenge.Level} />

                    {isActive ? (
                        <Link
                            className="er-button er-button-primary er-chCta"
                            to="/reservas"
                            onClick={() => handleClick(challenge.ChallengeId)}
                        >
                            Reservar
                        </Link>
                    ) : (
                        <button className="er-button er-chCta er-chCta-disabled" type="button" disabled>
                            Reservar
                        </button>
                    )}
                </div>
            </article>
        );
    };

    return (
        <div className="er-page">
            {/*<SummerBanner></SummerBanner>*/}
            <section className="er-hero" aria-label="Escape Room Bragança">
                <picture className="er-heroMedia">
                    <source media="(max-width: 600px)" srcSet={backgroundImageMobile} />
                    <img src={backgroundImage} alt="" className="er-heroImg" />
                </picture>

                <div className="er-heroOverlay">
                    <div className="er-balloons" aria-hidden="true">
                        <button
                            type="button"
                            className={`er-balloon b1 ${poppedBalloons.b1 ? 'is-popped' : ''}`}
                            aria-label="Balloon"
                            onClick={() => handlePopBalloon('b1')}
                        />
                        <button
                            type="button"
                            className={`er-balloon b2 ${poppedBalloons.b2 ? 'is-popped' : ''}`}
                            aria-label="Balloon"
                            onClick={() => handlePopBalloon('b2')}
                        />
                        <button
                            type="button"
                            className={`er-balloon b3 ${poppedBalloons.b3 ? 'is-popped' : ''}`}
                            aria-label="Balloon"
                            onClick={() => handlePopBalloon('b3')}
                        />
                        <button
                            type="button"
                            className={`er-balloon b4 ${poppedBalloons.b4 ? 'is-popped' : ''}`}
                            aria-label="Balloon"
                            onClick={() => handlePopBalloon('b4')}
                        />
                        <button
                            type="button"
                            className={`er-balloon b5 ${poppedBalloons.b5 ? 'is-popped' : ''}`}
                            aria-label="Balloon"
                            onClick={() => handlePopBalloon('b5')}
                        />
                    </div>
                    <div className="er-container er-heroInner">
                        <div className="er-heroBadge">A nossa sala fez 2 anos!</div>

                        <h1 className="er-heroTitle">Escape Room Bragança</h1>
                        <p className="er-heroSubtitle">
                            Dois anos a criar histórias, mistérios e memórias. Junta o teu grupo e vem viver um desafio inesquecível.
                        </p>

                        <div className="er-heroFeature">
                            <img src={cardImage} className="er-heroFeatureImg" alt="" />
                            <div className="er-heroFeatureText">
                                <div className="er-heroKicker">Em destaque</div>
                                <div className="er-heroFeatureTitle">O Viajante do Tempo</div>
                                <div className="er-heroFeatureSub">Que mistérios esconde?</div>
                            </div>
                        </div>

                        <div className="er-heroCtas">
                            <Link className="er-button er-button-primary" to="/reservas" onClick={() => handleClick('3')}>
                                Reservar agora
                            </Link>
                            <a className="er-button er-button-secondary" href="#desafios">
                                Ver desafios
                            </a>
                        </div>

                        <div className="er-heroChips" aria-label="Destaques">
                            <div className="er-chip">
                                <span className="er-chipTop">Cidade</span>
                                <span className="er-chipBottom">Bragança</span>
                            </div>
                            <div className="er-chip">
                                <span className="er-chipTop">Experiência</span>
                                <span className="er-chipBottom">60 min</span>
                            </div>
                            <div className="er-chip">
                                <span className="er-chipTop">Grupos</span>
                                <span className="er-chipBottom">1–5 pessoas</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="desafios" className="er-section">
                <div className="er-container">
                    <div className="er-sectionHead">
                        <h2 className="er-sectionTitle">Os nossos desafios</h2>
                        <p className="er-sectionSubtitle">Escolhe a história. Nós tratamos do resto.</p>
                    </div>

                    {isLoading ? (
                        <div className="er-emptyState">A carregar desafios…</div>
                    ) : hasError ? (
                        <div className="er-emptyState">
                            Não foi possível carregar os desafios neste momento. Tenta novamente mais tarde.
                        </div>
                    ) : (
                        <div className="er-chGrid">
                            {sortedChallenges.map((challenge) => (
                                <ChallengeCard key={challenge.ChallengeId} challenge={challenge} />
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default Desafios;